export default __webpack_public_path__ + "static/media/work11.759b8d77.svg";